import React from 'react';
import { MdSupervisedUserCircle } from 'react-icons/md';

import Modal, { ModalType } from 'legacy/common/components/modal/Modal';
import Button, { ButtonType } from 'legacy/common/components/button/Button';
import OrganizationsList from './OrganizationsList';
import UsersList from './UsersList';

function OrganizersGuestsModal({ onClose, isOpen, data }) {
  return (
    <Modal
      visible={isOpen}
      onClose={onClose}
      type={ModalType.SMALL}
      title="Organizers"
      icon={<MdSupervisedUserCircle size={20} />}
      renderFooter={() => (
        <Button type={ButtonType.Primary} onClick={onClose}>
          Close
        </Button>
      )}
    >
      <div className="pt-7 pb-[70px] px-4">
        {data.groups.length > 0 && (
          <div className="pb-7">
            <div className="pb-1">Organizations</div>
            <OrganizationsList users={data.groups} />
          </div>
        )}
        <div className="pb-7">
          <div className="pb-1">Cohosts</div>
          <UsersList users={[...data.cohosts, data.host]} />
        </div>
        {data.operators.length > 0 && (
          <div className="pb-7">
            <div className="pb-1">Operators</div>
            <UsersList users={data.operators} />
          </div>
        )}
        {data.scanners.length > 0 && (
          <div className="pb-7">
            <div className="pb-1">Scanners</div>
            <UsersList users={data.scanners} />
          </div>
        )}
        {data.photographers.length > 0 && (
          <div>
            <div className="pb-1">Photographers</div>
            <UsersList users={data.photographers} />
          </div>
        )}
      </div>
    </Modal>
  );
}

export default OrganizersGuestsModal;
